import type { JobRoundModel } from "@/src/types/roundModel"

export const NEW_MANDATE_CREATED_URL_KEY = "uploadMandateLeadId"
export const EDIT_MANDATE_STORAGE_KEY = "edit_mandates_id"

export const CANDIDATES_PAGE_FILTERS_STORAGE_KEY = "candidates_page_filters"
export const INTERVIEWS_PAGE_FILTERS_STORAGE_KEY = "interviews_page_filters"
export const SELECTION_PAGE_FILTERS_STORAGE_KEY = "selection_page_filters"
export const JOBS_PAGE_FILTERS_STORAGE_KEY = "jobs_page_filters"
export const BULK_UPLOAD_PAGE_FILTERS_STORAGE_KEY = "bulk_upload_page_filters"

export const CANDIDATES_PAGE_SEARCH_QUERY_STORAGE_KEY = "candidates_page_search_query"
export const INTERVIEWS_PAGE_SEARCH_QUERY_STORAGE_KEY = "interviews_page_search_query"
export const SELECTION_PAGE_SEARCH_QUERY_STORAGE_KEY = "selection_page_search_query"
export const JOBS_PAGE_SEARCH_QUERY_STORAGE_KEY = "jobs_page_search_query"

export const CURRENT_WORKSPACE_ID_STORAGE_KEY = "current_workspace_id"
export const CURRENT_WORKSPACE_ROLE_STORAGE_KEY = "current_workspace_role"
export const CANDIDATE_TOKEN_STORAGE_KEY = "candidate_token"
/** Set when visiting `/interview/:hash` so phone-only apply can call partner `send-otp` with the same hash. */
export const PARTNER_CANDIDATE_INTERVIEW_HASH_KEY = "partner_candidate_interview_hash"
export const WORKSPACE_CREATE_USER_ID_STORAGE_KEY = "workspace_create_user_id"
export const WORKSPACE_CREATE_USER_NAME_STORAGE_KEY = "workspace_create_user_name"

export const REEVALUATION_ALLOWED_STATUSES = ["NOT_MATCHED", "NO_RESPONSE", "MATCHED"]

export const SCREENING_QUESTION_TYPES = [
    {
        label: "Yes/No",
        value: "YES_NO",
    },
    {
        label: "Numeric",
        value: "NUMERIC",
    },
    {
        label: "From a list",
        value: "FROM_A_LIST",
    },
    {
        label: "Free Text",
        value: "FREE_TEXT",
    },
]

/** Minimal data from POST .../jobs/:id/activate for post-activate sourcing (first round only). Full job comes from GET. */
export type PostActivateSourcingBootstrap = {
    jobId: string
    firstRound?: JobRoundModel
}

export type JobPostingModalStatus =
    | "loading"
    | "success"
    | "sourcing"
    | "closed"
    | "howLinkWorks"
    | "addCandidates"
    | "embedLinkedInPost"

/** Passed via react-router `location.state` when navigating to candidates so JobSourcingModal can reopen after route change. */
export type JobSourcingPostNavigationState = {
    openJobSourcingModal: true
    jobSourcingModalStatus: JobPostingModalStatus
    /** Mirrors URL params so CandidatesPage can recover if search is not ready on first paint. */
    jobId?: string
    currentRoundId?: string
}
